<mat-card class="cardWithShadow">
    <mat-card-content class="p-24 table-responsive">
      <div class=" m-t-30 table_top_debtors">
        <table
          mat-table
          [dataSource]="dataSource"
          class="w-100"
          matSort
          matSortDirection="asc"
        >
          <!-- Position Column -->
          <ng-container matColumnDef="debtorName">
            <th
              mat-header-cell
              mat-sort-header
              *matHeaderCellDef
              class="th-title"
            >
              Nombre
            </th>
            <td mat-cell *matCellDef="let element" class="mat-body-1">
              <h6>
                {{ element.debtorName }}
              </h6>
            </td>
            <td mat-footer-cell *matFooterCellDef class="text-footer">
                Total
            </td>
          </ng-container>
  
          <!-- Name Column -->
          <ng-container matColumnDef="debtorRut">
            <th
              mat-header-cell
              *matHeaderCellDef
              mat-sort-header
              class="th-title"
            >
              Rut
            </th>
            <td mat-cell *matCellDef="let element" class="mat-body-1">
              <h6>
                {{ element.debtorRut }}
              </h6>
            </td>
            <td mat-footer-cell *matFooterCellDef>
            </td>

          </ng-container>
          <ng-container matColumnDef="sellInvoiceTotalAmount">
            <th
              mat-header-cell
              *matHeaderCellDef
              mat-sort-header
              class="th-title"
            >
              Monto Total de Ventas
            </th>
            <td mat-cell *matCellDef="let element" class="mat-body-1">
              <h6>
                ${{ element.sellInvoiceTotalAmount | number }}
              </h6>
            </td>
            <td mat-footer-cell *matFooterCellDef class="text-footer">
                ${{ calculateTotalSellInvoices() | number }}
            </td>
          </ng-container>
  
          <!-- Symbol Column -->
          <ng-container matColumnDef="numSellInvoices">
            <th
              mat-header-cell
              *matHeaderCellDef
              mat-sort-header
              class="th-title"
            >
              Facturas
            </th>
            <td mat-cell *matCellDef="let element" class="mat-body-1">
              <h6>{{ element.numSellInvoices }}</h6>
            </td>
            <td mat-footer-cell *matFooterCellDef>
            </td>
          </ng-container>
          <ng-container matColumnDef="transferInvoiceTotalAmount">
            <th
              mat-header-cell
              *matHeaderCellDef
              mat-sort-header
              class="th-title"
            >
              Monto Total Cedido
            </th>
            <td mat-cell *matCellDef="let element" class="mat-body-1">
              <h6>{{ element.transferInvoiceTotalAmount | currency:'CLP':'symbol' }}</h6>
            </td>
            <td mat-footer-cell *matFooterCellDef class="text-footer">
                ${{calculateTotalTransferInvoices() | number}}
            </td>
          </ng-container>
          <!-- <ng-container matColumnDef="transferInvoiceTotalAmount">
            <th
              mat-header-cell
              *matHeaderCellDef
              mat-sort-header
              class="th-title"
            >
             Aval
            </th>
            <td mat-cell *matCellDef="let element" class="mat-body-1">
              <h6>AVAL</h6>
            </td>
            <td mat-footer-cell *matFooterCellDef class="text-footer">
                {{isAval}}
            </td>
          </ng-container>
   -->
          <ng-container matColumnDef="numTransferInvoices">
            <th
              mat-header-cell
              mat-sort-header
              *matHeaderCellDef
              class="th-title"
            >
              Facturas Cedidas
            </th>
            <td mat-cell *matCellDef="let element" class="mat-body-1">
              <h6>{{ element.numTransferInvoices }}</h6>
            </td>
            <td mat-footer-cell *matFooterCellDef>
            </td>
          </ng-container>
    
          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr
            mat-row
            *matRowDef="let row; columns: displayedColumns" >
          </tr>
          <tr mat-footer-row *matFooterRowDef="displayedColumns"></tr>
  
        </table>
      </div>
    </mat-card-content>
  </mat-card>
  